enum TabsEnum {
    value = 'value',
    founder = 'founder',
    team = 'team',
    company = 'company'
}

export default TabsEnum;
